import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { motion } from 'framer-motion';

const Hero = () => {
    return (
        <div id="home" className="relative h-screen w-full">
            {/* Background Image */}
            <div 
                className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: "url('/background_image.svg')",
                    backgroundBlendMode: 'overlay',
                }}
            >
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/50"></div>
            </div>

            {/* Content */}
                                    <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 md:px-6 max-w-7xl mx-auto">
                                        <h1 className="text-4xl md:text-6xl font-bold text-white text-center max-w-4xl mb-8">
                                            {"Building with purpose and creating lasting value".split(" ").map((word, index) => (
                                                <motion.span
                                                    key={index}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{
                                                        duration: 0.5,
                                                        delay: index * 0.2,
                                                        ease: "easeOut"
                                                    }}
                                                    className="inline-block mr-2"
                                                >
                                                    {word}
                                                </motion.span>
                                            ))}
                                        </h1>

                                        <motion.a 
                                            href="#about"
                                            onClick={(e) => {
                                    e.preventDefault();
                                    // First animate the current view
                                    const currentView = document.querySelector('#home');
                                    currentView.style.opacity = '0';
                                    currentView.style.transition = 'opacity 0.5s ease-out';
                                    
                                    // Then scroll after animation
                                    setTimeout(() => {
                                        document.querySelector('#about').scrollIntoView({ behavior: 'smooth' });
                                        // Reset opacity
                                        currentView.style.opacity = '1';
                                    }, 500);
                        e.preventDefault();
                        document.querySelector('#about').scrollIntoView({ behavior: 'smooth' });
                    }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 2 }}
                    className="flex items-center gap-2 bg-[#EE3238] text-white px-8 py-3 rounded-full hover:bg-purple-600 transition-all duration-300"
                >
                    Learn More
                    <motion.div
                    animate={{
                        scale: [1, 1.2, 1],
                    }}
                    transition={{
                        duration: 1.5,
                        repeat: Infinity,
                        repeatType: "reverse",
                        ease: "easeInOut"
                    }}
                >
                    <FaArrowRight className="ml-2" />
                </motion.div>
                </motion.a>
            </div>
        </div>
    );
};

export default Hero;